// libs
import React, { memo } from 'react';
import { styled } from '@nykaa/ui-components';

// icon
import CirclePlay from '@nykaa/ui-components/Icons/circle-play-filled';

// hook
import useTheme from '@nykaa/ui-components/themes/hooks/useTheme';

// type
import { Theme } from '@nykaa/ui-components/themes/types';

const Container = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
`;

function VideoPlayeButton() {
  const theme: Theme = useTheme();
  return (
    <Container>
      <CirclePlay color={theme?.colors?.surface} />
    </Container>
  );
}

export default memo(VideoPlayeButton);
